const getDefaultChickletSecondaryDisplayLabels = () => {
  return {
    propertyFormatters: {},
    copyDisabled: false
  };
};
export default getDefaultChickletSecondaryDisplayLabels;